import { AxiosService } from '../../axios/axios.service';
import {
  tAnalyticsResponse,
  tGetAnalyticsDataResponse,
  tMessagesCountRequest,
} from './Analytics.types';

export const AnalyticsService = {
  getAnalyticsData: async function (
    request: tMessagesCountRequest,
  ): Promise<tAnalyticsResponse<tGetAnalyticsDataResponse>> {
    try {
      const response = await AxiosService.get<
        tAnalyticsResponse<tGetAnalyticsDataResponse>
      >(`/analytics/${request.wid}`, {
        params: {
          startDate: request.start_date,
          endDate: request.end_date,
          ...(request.compare && { compare: request.compare }),
          ...(request.seller && { seller: request.seller }),
        },
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
